export default __webpack_public_path__ + "static/DSC_0373-1055c0f011f34daca1b7b5e6bf3ab7d2.jpg";